import { Skeleton } from '@mui/material';

export const TableLoader = ({ headerArray, itemArray }) => {
  return (
    <div class="table-resposnive table-div">
      <table class="table datatable">
        <thead>
          <tr>
            {headerArray?.map((data, ind) => (
              <th key={ind}>{data}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[1, 2, 3, 4, 5, 6, 6, 7, 8, 9, 10]?.map((item, key) => (
            <tr key={key}>
              {itemArray?.map((data, ind) => (
                <td key={ind}>
                  <Skeleton height={60} width={'100%'} style={{ margin: 0 }} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export const SingleTableLoader = ({ itemArray }) => {
  return (
    <tr>
      {itemArray?.map((data, ind) => (
        <td key={ind}>
          <Skeleton height={60} width={'100%'} style={{ margin: 0 }} />
        </td>
      ))}
    </tr>
  );
};
